import {
  IPageContext,
  SERVICE_TYPES,
  IRestService,
} from '@glidecms/deliver-core-dev/types/services'
import { IImage } from '../interfaces'

export const getImage = async (context: IPageContext, imageId: string): Promise<IImage> => {
  if (!imageId) {
    return
  }

  const imageService = context.getService<IRestService>(SERVICE_TYPES.IRestService)
  const { data: image } = await imageService.get(`/images/${imageId}`)

  return image
}
